module.exports = __webpack_public_path__ + "img/department.b2f4a12c.png";